import { Pill } from "@clipboard-health/ui-components";

export type Consequence = number | "Restriction" | "On Restriction" | "Instant restriction";
interface ConsequencePillProps {
  consequence: Consequence;
}

export function ConsequencePill({ consequence }: ConsequencePillProps) {
  const isRestricted = consequence === "On Restriction";
  const isNoConsequence = typeof consequence === "number" && consequence === 0;
  const isNegativeConsequence =
    consequence === "Instant restriction" ||
    consequence === "Restriction" ||
    (typeof consequence === "number" && consequence < 0);

  let label = `+ ${consequence} pts`;

  if (typeof consequence === "string") {
    label = consequence;
  } else if (consequence < 0) {
    label = `- ${Math.abs(consequence)} pts`;
  }

  return (
    <Pill
      label={label}
      size="small"
      color={(theme) => {
        if (isRestricted || isNoConsequence) {
          return theme.palette.common.black;
        }

        return isNegativeConsequence
          ? theme.palette.intent?.error.text
          : theme.palette.intent?.success.text;
      }}
      backgroundColor={(theme) => {
        if (isRestricted || isNoConsequence) {
          return theme.palette.grey[200];
        }

        return isNegativeConsequence
          ? theme.palette.intent?.error.background
          : theme.palette.intent?.success.background;
      }}
    />
  );
}
